import { render, staticRenderFns } from "./Corpo.vue?vue&type=template&id=6c6e3a70&scoped=true&"
import script from "./Corpo.vue?vue&type=script&lang=js&"
export * from "./Corpo.vue?vue&type=script&lang=js&"
import style0 from "./Corpo.vue?vue&type=style&index=0&id=6c6e3a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e3a70",
  null
  
)

export default component.exports